"use client";

import Link from "next/link";
import styles from "./error.module.scss";

/**
 * エラー発生時表示される コンポーネント
 * @returns {JSX.Element} エラー発生時表示される コンポーネント
 */
export default function Error() {
	return (
		<div className={styles.error}>
			<p className={styles.message}>
				問題が発生しました。
				<br />
				時間を開けて再度お試しください。
			</p>
			<Link href="/" className={styles.link}>
				Topページへ
			</Link>
		</div>
	);
}
